import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useLightVsDarkStyles = createUseStyles((theme: Theme) => {
    return {
        wrapper: {
            position: 'relative',
            width: '100%',
            overflow: 'hidden',
        },
        leftSide: {
            backgroundColor: theme.colors.latte_cream,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            overflow: 'hidden',
            minHeight: '55vh',
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',
                minHeight: 'auto',
                paddingTop: theme.spacing(3),
                paddingBottom: theme.spacing(3),
            },
        },
        rightSide: {
            backgroundColor: theme.colors.espresso_brown,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            overflow: 'hidden',
            minHeight: '55vh',
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'auto',
                paddingTop: theme.spacing(3),
                paddingBottom: theme.spacing(3),
            },
        },
        characterLeft: {
            height: '55vh',
            width: 'auto',
            objectFit: 'contain',
            display: 'block',
            [theme.breakpoints.down('md')]: {
                height: 'auto',
                width: '70%',
                maxWidth: '300px',
            },
        },
        characterRight: {
            height: '55vh',
            width: 'auto',
            objectFit: 'contain',
            display: 'block',
            [theme.breakpoints.down('md')]: {
                height: 'auto',
                width: '70%',
                maxWidth: '300px',
            },
        },
        separatorImg: {
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            height: '100%',
            width: 'auto',
            zIndex: 1,
            objectFit: 'contain',
            pointerEvents: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        logoBattleDesktop: {
            position: 'absolute',
            top: '30%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'max(180px, 14vw)',
            zIndex: 2,
            pointerEvents: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        tapDesktop: {
            position: 'absolute',
            bottom: 0,
            left: '48%',
            transform: 'translateX(-50%)',
            height: '43%',
            width: 'auto',
            zIndex: 2,
            pointerEvents: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        logoBattleMobile: {
            display: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'block',
                width: '55vw',
                maxWidth: '280px',
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
            },
        },
        tapMobile: {
            display: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'block',
                width: '50vw',
                maxWidth: '260px',
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
            },
        },
        separatorImgMobile: {
            display: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(85deg)',
                width: '20%',
                height: 'auto',
                zIndex: 1,
                pointerEvents: 'none',
            },
        },
    };
});

export default useLightVsDarkStyles;